import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api, fmtUSD, fmtDate, OFFER_TYPES } from "@/lib/api";

export default function MyOffers() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/offers/mine"); setItems(data); } catch {}
      setLoading(false);
    })();
  }, []);
  return (
    <DashboardLayout>
      <p className="eyebrow">My offers</p>
      <h1 className="font-display text-3xl font-semibold mt-2">All offers I've submitted</h1>
      {loading ? <p className="mt-6 text-sm text-[var(--adn-text-soft)]">Loading…</p> :
        items.length === 0 ? <p className="mt-10 text-sm text-[var(--adn-text-soft)]">No offers submitted yet.</p> :
        <div className="mt-6 bg-white border border-[var(--adn-line)]">
          <table className="w-full text-sm">
            <thead className="bg-[var(--adn-cream)] text-left text-[10px] uppercase tracking-[0.15em] text-[var(--adn-text-muted)]">
              <tr>
                <th className="px-4 py-3">Type</th>
                <th className="px-4 py-3">Amount</th>
                <th className="px-4 py-3">Close</th>
                <th className="px-4 py-3">Status</th>
                <th className="px-4 py-3">Submitted</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[var(--adn-line)]">
              {items.map((o) => (
                <tr key={o.offer_id} className="hover:bg-slate-50">
                  <td className="px-4 py-3 font-medium">{OFFER_TYPES.find(x=>x.id===o.offer_type)?.label || o.offer_type}</td>
                  <td className="px-4 py-3 tabular">{fmtUSD(o.amount)}</td>
                  <td className="px-4 py-3 tabular">{o.closing_days ? `${o.closing_days}d` : "—"}</td>
                  <td className="px-4 py-3"><span className={`pill ${o.status === "accepted" ? "pill-accepted" : o.status === "rejected" ? "pill-rejected" : "pill-pending"}`}>{o.status}</span></td>
                  <td className="px-4 py-3 text-[var(--adn-text-soft)]">{fmtDate(o.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      }
    </DashboardLayout>
  );
}
